import removeTrailingSlash from 'remove-trailing-slash';

export const REDIRECT_QUERY = `
    query Redirect($retourUri: String, $retourUriTrailing: String, $locale: String) {
        redirect: retourResolveRedirect(uri: $retourUri, site: $locale) {
            redirectDestUrl
            redirectSrcUrl
            redirectHttpCode
            siteId
        }
        redirectTrailing: retourResolveRedirect(uri: $retourUriTrailing, site: $locale) {
            redirectDestUrl
            redirectSrcUrl
            redirectHttpCode
            siteId
        }
    }
`;

const SITE_ID_MAP = {
    1: 'de',
    2: 'en',
    3: 'nl',
};

type RedirectResponse = {
    redirectDestUrl: string;
    redirectHttpCode: number;
};
const hasRedirect = async (uri: string, locale: string): Promise<RedirectResponse | null> => {
    const res = await fetch(process.env.NEXT_PUBLIC_API_URL ?? '', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({
            query: REDIRECT_QUERY,
            variables: {
                retourUri: `/${uri}`,
                retourUriTrailing: `/${uri}/`,
                locale,
            },
        }),
    });

    if (!res.ok) return null;

    const json = await res.json();

    const { redirect, redirectTrailing } = json.data ?? {};

    if (!redirect && !redirectTrailing) {
        return null;
    }

    const { redirectDestUrl, redirectSrcUrl, redirectHttpCode, siteId } = redirect.redirectDestUrl
        ? redirect
        : redirectTrailing;

    if (!redirectDestUrl || !redirectSrcUrl) {
        return null;
    }

    const redirectLocale = SITE_ID_MAP[siteId as keyof typeof SITE_ID_MAP];

    // only allow redirect in same locale
    if (redirectLocale !== locale) {
        return null;
    }

    const srcUrl = new URL(redirectSrcUrl, 'http://contoso.com');
    const destUrl = new URL(redirectDestUrl, 'http://contoso.com');

    const srcPathname = removeTrailingSlash(srcUrl.pathname).toLowerCase();
    const destPathname = removeTrailingSlash(destUrl.pathname).toLowerCase();

    // normalization, because this redirect data is pure trash and it contains lots of infinite loops.
    return srcPathname !== destPathname ? { redirectDestUrl, redirectHttpCode } : null;
};

export default hasRedirect;
